<template>
  <div class="share-hotel-confirm-rechange">
    <nav-bar
      class="nav-bar"
      titleText="确认充值"
      fontColor="#333333"
      @goBack="goBack"
    ></nav-bar>
    <div class="store-info">
      <div class="title">
        <img :src="shopInfo.logo" />
        <span>{{ shopInfo.shop_name }}</span>
      </div>
      <div class="actual-amount">
        <span class="left">实付金额</span>
        <span class="right"
          >¥ {{ parseFloat(shopInfo.recharge_amount).toFixed(2) }}</span
        >
      </div>
    </div>
    <div class="empty"></div>
    <div class="use-vecoin-box">
      <div class="vecoin-select">
        <span v-if="can_use == 1 && !coinSelected"
          >可用红包为 <span class="two"> {{ shopInfo.now_coin }}</span> 元</span
        >
        <span v-if="can_use == 1 && coinSelected"
          >红包可抵扣<span class="two">
            {{ shopInfo.if_use_now_coin.can_deduct_credit }}</span
          >
          元</span
        >
        <span v-if="can_use == -1">红包可用余额不足100，无法抵扣</span>
        <img
          src="../../assets/shared-hotel/use-selected.png"
          v-if="can_use == 1 && !coinSelected"
          @click="parseFloat(shopInfo.now_coin) > 0 ? confrimClick() : ''"
        />
        <img
          src="../../assets/shared-hotel/red-selected.png"
          v-if="can_use == 1 && coinSelected"
          @click="parseFloat(shopInfo.now_coin) > 0 ? confrimClick() : ''"
        />
        <!-- <img src="../../assets/shared-hotel/un-selected.png" v-if="can_use == -1" @click="coinSelected = coinSelected == 1 ? -1 : 1"> -->
        <img
          src="../../assets/shared-hotel/un-selected.png"
          v-if="can_use == -1"
        />
      </div>
      <div class="attention">注：红包单次最高可使用订单金额的50%</div>
      <div class="invoice_tip">
        <span class="invoice_title">开具发票</span>
        <span class="invoice_text">如需开具发票，请提前与商家确认</span>
      </div>
    </div>
    <div class="rechange-info">
      <div class="span phone">
        <span class="left">手机号码</span>
        <span>： {{ shopInfo.member_mobile }}</span>
      </div>
      <div class="span rechange-amount">
        <span class="left">充值金额</span>
        <span>： {{ rechangeAmount }}</span>
      </div>
      <div class="span per-amount" v-if="shopInfo.present_amount">
        <span class="left">赠送金额</span>
        <span>： {{ presentAmount }}</span>
      </div>
      <div class="all-amount">
        <span class="left">总计</span>
        <span>： {{ orderAmount }}</span>
      </div>
    </div>

    <div class="bottom-box">
      <div class="rea-amount">
        <div class="title">实付款：</div>
        <span>¥{{ actualAmount }}</span>
      </div>
      <div class="button" @click="submitOrder">
        <span>提交订单</span>
      </div>
    </div>
    <div class="loading" v-if="loading">
      <img src="../../assets/common/loading.gif" />
    </div>
  </div>
</template>

<script>
import navBar from "./components/navBar";
import dsbridge from "dsbridge";
export default {
  name: "confirmRechange",
  data() {
    return {
      coinSelected: false,
      shopInfo: this.$route.query.shopInfo,
      can_use: this.$route.query.shopInfo.now_coin_status,
      // can_use: -1,
      actualAmount: this.$route.query.shopInfo.recharge_amount,
      confirmData: {},
      loading: false,
      equipment: null,
      actual_amount: 0,
    };
  },
  components: {
    navBar,
  },
  computed: {
    rechangeAmount() {
      return parseFloat(this.shopInfo.recharge_amount).toFixed(2);
    },
    presentAmount() {
      return parseFloat(this.shopInfo.present_amount).toFixed(2);
    },
    orderAmount() {
      return parseFloat(this.shopInfo.order_amount).toFixed(2);
    },
  },
  created() {
    this.deductionUA();
  },
  mounted() {
    window.setPay = this.setPay;
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    confrimClick() {
      this.coinSelected = !this.coinSelected;

      const isUseCoin = this.coinSelected ? 1 : 0;

      const common1 = {
        shop_id: this.shopInfo.shop_id,
        order_amount: this.shopInfo.recharge_amount,
        is_use_deduct_credit2: isUseCoin,
        scan_type: 1,
        recharge_amount: this.shopInfo.recharge_amount,
        present_amount: this.shopInfo.present_amount,
        is_recharge_to_card: 1,
      };
      const param1 = {
        order: {
          type: "scan_order",
        },
        ...common1,
      };
      this.$api
        .post("/order/member/order/confirm", param1)
        .then((data) => {
          this.actualAmount = parseFloat(data.actual_amount).toFixed(2);
          this.confirmData = data;
        })
        .catch((err) => {
          err.message && this.$toast(err.message);
        });
    },
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        this.equipment = 11;
      } else if (/android/.test(ua)) {
        this.equipment = 10;
      }
    },
    setPay(v) {
      let data = JSON.parse(v);
      if (data.code == 0) {
        this.$router.push({
          //支付成功
          path: "/sharedHotel/paymentResult",
          query: {
            actual_amount: this.actual_amount,
            type: 0,
            shop_id: this.shopInfo.shop_id,
          },
        });
      } else {
        this.$router.go(-1);
      }
    },
    async submitOrder() {
      this.loading = true;
      try {
        const isUseCoin = this.coinSelected ? 1 : 0;
        const common = {
          shop_id: this.shopInfo.shop_id,
          order_amount: this.shopInfo.recharge_amount,
          is_use_deduct_credit2: isUseCoin,
          scan_type: 1,
          recharge_amount: this.shopInfo.recharge_amount,
          present_amount: this.shopInfo.present_amount,
          is_recharge_to_card: 1,
        };

        if (common.is_use_deduct_credit2 == 0) {
          const param1 = {
            order: {
              type: "scan_order",
            },
            ...common,
          };
          this.confirmData = await this.$api.post(
            "/order/member/order/confirm",
            param1
          );
        }
        const param2 = {
          order: {
            client: this.client || 10,
            type: "scan_order",
            confirm: this.confirmData.order.confirm,
          },
          ...common,
        };
        const data2 = await this.$api.post(
          "/order/member/order/create",
          param2
        );
        this.actual_amount = data2.actual_amount;
        const param3 = {
          ordersn: data2.ordersn,
          actual_amount: data2.actual_amount,
          order_type: "card_bag_recharge_return",
          order_amount: data2.order_amount,
        };
        if (this.equipment === 11) {
          let that = this;
          dsbridge.call("goPay", JSON.stringify(param3), function (v) {
            that.setPay(v);
          });
        } else if (this.equipment === 10) {
          this.params(JSON.stringify(param3), JSON.stringify(param3), "goPay");
        }
        // this.params(JSON.stringify(param3), JSON.stringify(param3), 'goPay')
        this.loading = false;
      } catch (error) {
        error.message && this.$toast(error.message);
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less">
.share-hotel-confirm-rechange {
  background-color: #f5f5f5;
  padding-top: 88px;
  min-height: calc(100% - 88px);
  overflow-y: auto;
  overflow-x: hidden;

  .store-info {
    background: #ffffff;
    margin: 10px 12px 0;
    border-radius: 10px 10px 0 0;

    .title {
      display: flex;
      justify-content: start;
      align-items: center;
      margin-bottom: 17px;
      padding: 15px 18px 0;

      img {
        width: 28px;
        height: 28px;
        margin-right: 9px;
        border-radius: 50%;
      }

      span {
        height: 25px;
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        line-height: 25px;
      }
    }

    .actual-amount {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 18px 18px;

      .left {
        height: 22px;
        font-size: 16px;
        color: #666666;
        line-height: 22px;
      }

      .right {
        height: 28px;
        font-size: 20px;
        color: #333333;
        line-height: 28px;
      }
    }
  }

  .empty {
    width: 100%;
    height: 1px;
    background: #f5f5f5;
    margin: 0 12px;
  }

  .use-vecoin-box {
    background: #ffffff;
    margin: 0 12px;
    border-radius: 0 0 10px 10px;

    .vecoin-select {
      padding: 15px 18px 6px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        height: 20px;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
      }

      .two {
        color: #f9591b;
        font-size: 14px;
      }

      img {
        width: 17px;
        height: 17px;
      }
    }

    .attention {
      height: 17px;
      font-size: 12px;
      color: #999999;
      line-height: 17px;
      padding: 0 18px 15px;
    }
    .invoice_tip {
      padding: 0 15px 15px 15px;
      box-sizing: border-box;
      .invoice_title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        margin: 0 10px 0 5px;
      }
      .invoice_text {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
    }
  }

  .rechange-info {
    background: #ffffff;
    margin: 10px 12px 0;
    border-radius: 10px;
    padding: 18px 18px;

    .left {
      width: 68px;
      text-align: justify;

      // text-align-last: justify;
      &::after {
        content: " ";
        display: inline-block;
        width: 100%;
      }
    }

    div {
      height: 22px;
      font-size: 16px;
      color: #666666;
      line-height: 22px;
      padding-bottom: 18px;
      display: flex;
    }

    .all-amount {
      padding-bottom: 0px;

      .span1 {
        text-align: justify;
      }

      span {
      }
    }
  }

  .bottom-box {
    // max-height: 49px;
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    background: #ffffff;
    padding: 12px 18px 33px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    .rea-amount {
      display: flex;
      align-items: center;

      .title {
        height: 25px;
        font-size: 18px;
        color: #333333;
        line-height: 25px;
      }

      span {
        height: 25px;
        font-size: 18px;
        line-height: 25px;
        color: #f9591b;
      }
    }

    .button {
      height: 40px;
      background: linear-gradient(90deg, #fc740c 0%, #f41a3c 100%);
      border-radius: 21px;
      text-align: center;
      line-height: 40px;

      span {
        height: 25px;
        font-size: 18px;
        font-weight: 600;
        color: #ffffff;
        line-height: 25px;
        padding: 8px 23px;
      }
    }
  }

  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);

    img {
      width: 35%;
      margin-top: 65%;
    }
  }
}
</style>
